import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAuth, getAuth, connectAuthEmulator } from '@angular/fire/auth';
import { provideFunctions, getFunctions, connectFunctionsEmulator } from '@angular/fire/functions';
import { provideFirestore, getFirestore, connectFirestoreEmulator } from '@angular/fire/firestore';
import { routes } from './app.routes';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    // Enable zoneless change detection (Angular 20)
    provideZonelessChangeDetection(),

    // Router
    provideRouter(routes),

    // Material animations
    provideAnimationsAsync(),

    // Firebase
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => {
      const auth = getAuth();
      // Connect to emulator in development if needed
      // if (!environment.production) {
      //   connectAuthEmulator(auth, 'http://localhost:9099');
      // }
      return auth;
    }),
    provideFunctions(() => {
      const functions = getFunctions();
      // Set region for cloud functions
      if (environment.functionsRegion) {
        (functions as any).region = environment.functionsRegion;
      }
      // Connect to emulator in development if needed
      // if (!environment.production) {
      //   connectFunctionsEmulator(functions, 'localhost', 5001);
      // }
      return functions;
    }),
    provideFirestore(() => {
      const firestore = getFirestore();
      // Connect to emulator in development if needed
      // if (!environment.production) {
      //   connectFirestoreEmulator(firestore, 'localhost', 8080);
      // }
      return firestore;
    })
  ],
};
